import React from 'react';
import {format} from 'date-fns';
import {
    View,
    StyleSheet,
    PDFViewer,
    Font,
    Document,
    Page,
    Text,
    Link,
    Image
} from "@react-pdf/renderer";
import STC from '../../../../../../../../STCLibrary/STCFactory/STCFactory';
import Logo from '../../../../../../../../Resources/Logo/logo2.png'

Font.register({
    family: "Roboto",
    fonts: [
        { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf", fontWeight: 300 },
        { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf", fontWeight: 400 },
        { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf", fontWeight: 500 },
        { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf", fontWeight: 600 },
    ],
});

// Font.register({
//     family: 'OpenSans',
//     fonts: [
//         { src: OpenSans400, fontWeight: 400 },
//         { src: OpenSans500, fontWeight: 500 },
//         { src: OpenSans600, fontWeight: 600 },
//     ],
// });


const styles = StyleSheet.create({
    page: {
        position: "relative",
        color: "#002060",
        fontFamily: "Roboto",
        fontWeight: 400,
        paddingHorizontal: '5%',
        paddingTop: '2%',
        paddingBottom: '4%',

    },
    footer: {
        position: "absolute",
        bottom: '2%',
        left: '2%',
        width: '100%',
    },
    section: {
        margin: 4,
        padding: 4
    },
    viewer: {
        width: '100%', //the pdf viewer will take up all of the width and height
        height: '90vh',
    },

    successInfo: {
        fontSize: 12,
        width: '100%',
        paddingTop: '1%',
        paddingHorizontal: '3%',
        backgroundColor: STC.Blue,
        color: '#ffffff',
        textAlign:'center'
    },
    headerLine: {
        display: 'flex',
        flexDirection: 'row',
    },
    logo: {
        width: '50%'
    },
    address: {
        fontSize: 8,
        opacity: 0.8,
        width: '30%'
    },
    table: {
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
        borderLeft: '2px solid black',
        borderRight: '2px solid black',
    },
    paymentTitleRow: {
        fontWeight: 600,
        borderBottom: '1px solid black',
        borderTop: '1px solid black',
        paddingLeft: '1%',
        backgroundColor: STC.Green,
        color: 'white'
    },
    tableRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderTop: '1px solid black',
        fontSize: 10
    },
    tableRowItemLeft: {
        fontWeight: 600,
        width: '50%',
        paddingLeft: '1%'
    },
    tableRowItemRight: {
        width: '50%',
        borderLeft: '1px solid black',
        paddingLeft: '2%'
        
    },
    paxDetailsInfo: {
        fontSize: 10,
        fontWeight: 600
    },
    paymentTerms: {
        fontSize: 10,
        width: '100%',
        paddingTop: '1%',
        paddingHorizontal: '3%',
        backgroundColor: STC.Blue,
        color: '#ffffff',
        textAlign:'center'
    },
    terms: {
        fontSize: 9
    },

});


export default function ReceiptDocument({payer, tour, passenger, payment}){

    const bookingConditionsLink = 'https://www.schooltour.ie/booking-conditions/';
 
    return(
        <>
            <PDFViewer style={styles.viewer}>
                <Document>
                    <Page wrap siz='A4' style={styles.page}>

                        <View style={styles.section}>
                            <View style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <Image style={styles.logo} src={Logo} />
                            </View>
                        </View>

                        <View style={styles.section}>
                            <View style={styles.successInfo}>
                                <Text>Your payment for {tour.title} was successful!</Text>
                            </View>
                        </View>
                        <View style={styles.section}>
                            <View style={styles.table}>
                                <View style={styles.paymentTitleRow}>
                                    <Text>Payment Details</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Payment Amount</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{payment.amount}</Text></View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Payment made with card ending</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>**0000</Text></View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Transaction ID</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>#ferjhdfjherhje</Text></View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Transaction Time</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{format(new Date(payment.createdDate), 'dd-LLL-yyyy')}</Text></View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Payment Contact Email</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{payer.email}</Text></View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Payment Contact Phone</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{payer.phone}</Text></View>
                                </View>
                            </View>
                            
                        </View>

                        <View style={styles.section}>
                            <View style={styles.table}>
                                <View style={styles.paymentTitleRow}>
                                    <Text>Tour Details</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Title</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{tour.title}</Text></View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>School</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{tour.schoolName}</Text></View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Booking ID</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{tour.bookingId}</Text></View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Destinations</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{tour.destinations.map((dest) => (dest + ' '))}</Text></View>
                                </View>
                            </View>
                        </View>

                        <View style={styles.section}>
                            <View style={styles.table}>
                                <View style={styles.paymentTitleRow}>
                                    <Text>Passenger Details</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Passenger Name</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{passenger.firstName} {passenger.surname}</Text></View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Gender</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{passenger.gender}</Text></View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableRowItemLeft}><Text>Date of Birth</Text></View>
                                    <View style={styles.tableRowItemRight}><Text>{passenger.dateOfBirth}</Text></View>
                                </View>
                            </View>
                        </View>

                        <View style={styles.section}>
                            <View style={styles.paxDetailsInfo}>
                                <Text>Passenger Details must be as per passport or fees will apply.</Text>
                                <Text>Please note that special characters such as apostrophes, fadas, or dashes will not show in your receipt. This will not affect your booking.</Text>
                            </View>
                        </View>

                        <View style={styles.section}>
                            <View style={styles.paymentTerms}>
                                <Text>Payment Terms</Text>
                            </View>
                            <View style={styles.terms}>
                                <Text>As you are paying through our website, you represent and warrant that when you make any payments to The School Tour Company for such use:</Text>
                                <View style={{flexDirection: 'row'}}>
                                    <Text style={{ marginHorizontal: 8, fontSize: 14 }}>•</Text>
                                    <Text>You agree that the full deposit amount is non-refundable but can be transferred to a replacement passenger, where an applicable name change fee may apply. <Link src={bookingConditionsLink}>(How much is the total deposit and how will my deposit be spent?)</Link></Text>
                                </View>

                                <View style={{flexDirection: 'row'}}>
                                    <Text style={{ marginHorizontal: 8, fontSize: 14 }}>•</Text>
                                    <Text>You agree that in the event of a cancellation or request for modification of the reservation, The School Tour Company and the service providers are not obliged to honour such requests and the entire amount paid is forfeited by the customer</Text>
                                </View>

                                <View style={{flexDirection: 'row'}}>
                                    <Text style={{ marginHorizontal: 8, fontSize: 14 }}>•</Text>
                                    <Text>You agree that refunds, if any, are provided at the sole discretion of The School Tour Company and the service providers</Text>
                                </View>

                                <View style={{flexDirection: 'row'}}>
                                    <Text style={{ marginHorizontal: 8, fontSize: 14 }}>•</Text>
                                    <View>
                                        <Text>You agree on the following cancellation charges:</Text>
                                        <Text>29 - 56 days prior to departure - 80% of the tour price.</Text>
                                        <Text>28 or less prior to departure - 100% of the tour price.</Text>
                                        <Text>Your cancellation should be emailed to the group leader</Text>
                                    </View>
                                </View>
                                
                                <View style={styles.section}>
                                    <Text>Having clicked 'Confirm & Pay' and made this payment, you have agreed to our <Link src={bookingConditionsLink}>Booking Conditions</Link> and the above payment terms</Text>
                                </View>
                            </View>
                            <View style={{opacity: 0.5, fontSize: 9, width: '100%',alignItems: 'center', justifyContent: 'center'}}>
                                <View ><Text>4th/5th Floor, 121/122 Capel Street, Dublin 1, D01 V3P0, Ireland t:  +353 1 253 0075 w: www.schooltour.ie</Text></View>
                            </View>
                        
                        </View>
                        
                        
                    </Page>
                    
                </Document>
            </PDFViewer>
        </>
    )
}